import {
  PageControlConfiguration,
  PageControlState,
} from "interfaces/pageControl";
import {
  extendOrderedArray,
  getConfiguration,
} from "app/utils";

const defaultPages: PageControlState = {
  pages: [
    {
      unique: "page_1",
      url: "travel-theme",
      title: "path_retrieve",
      sequence: 0,
      enabled: true,
      isActive: true,
      isPrevious: false,
      isCommon: true,
      show: true,
      showBack: false,
      showForward: true,
      skipLogging: false,
    },
    {
      unique: "page_2",
      url: "compose-trip",
      enabled: false,
      title: "path_details",
      isActive: false,
      isPrevious: false,
      isCommon: true,
      show: true,
      sequence: 1,
      showBack: true,
      showForward: true,
      skipLogging: false,
    },
    {
      unique: "page_3",
      url: "passengers",
      sequence: 2,
      enabled: false,
      title: "path_paxs",
      isActive: false,
      isPrevious: false,
      isCommon: true,
      show: true,
      showBack: true,
      showForward: true,
      skipLogging: true,
    },
    {
      unique: "page_4",
      url: "summary",
      sequence: 3,
      enabled: false,
      title: "path_payment",
      isActive: false,
      isPrevious: false,
      isCommon: true,
      show: true,
      showBack: true,
      showForward: true,
      skipLogging: false,
    },
    {
      unique: "page_5",
      url: "confirmation",
      sequence: 4,
      enabled: false,
      title: "path_confirmation",
      isActive: false,
      isPrevious: false,
      isCommon: true,
      show: true,
      showBack: true,
      showForward: true,
      backUrl: "travel-theme",
      skipLogging: true,
    },
  ],
  renderIndex: 0,
};

const lxsLhsSnsPages: PageControlConfiguration[string] = {
  extraPages: {
    pages: [
      {
        unique: "page_payment",
        url: "payment",
        sequence: 4,
        enabled: false,
        title: "path_payment",
        isActive: false,
        isPrevious: false,
        isCommon: true,
        show: true,
        showBack: true,
        showForward: true,
        skipLogging: true,
      },
    ],
    sortingField: "sequence",
  },
  pageOverrides: [
    {
      unique: "page_4",
      title: "path_summary",
    },
  ],
}

const customerConfiguration: PageControlConfiguration = {
  ewg: {
    extraPages: {
      pages: [
        {
          unique: "ewg_page_fare",
          url: "fare",
          sequence: 2,
          enabled: false,
          title: "path_fare",
          isActive: false,
          isPrevious: false,
          isCommon: true,
          show: true,
          showBack: true,
          showForward: true,
          skipLogging: true,
        },
      ],
      sortingField: "sequence",
    },
    pageOverrides: [
      {
        unique: "page_3",
        skipLogging: false,
      },
    ],
  },
  lxs: lxsLhsSnsPages,
  lhs: lxsLhsSnsPages,
  sns: lxsLhsSnsPages,
  oss: lxsLhsSnsPages,
  default: {}
};

function getCustomerPages() {
  const pageConfiguration = getConfiguration(customerConfiguration);
  const extraPages = pageConfiguration.extraPages;
  const pageOverrides = pageConfiguration.pageOverrides;

  let pages: PageControlState = defaultPages;
  if (extraPages) {
    pages.pages = extendOrderedArray(
      defaultPages.pages,
      extraPages.pages,
      extraPages.sortingField,
    );
  }

  if (pageOverrides) {
    pages.pages = pages.pages.map((page) => {
      const currentPage = pageOverrides.find(
        (override) => override.unique === page.unique,
      );
      if (currentPage) {
        return {
          ...page,
          ...currentPage,
        };
      }
      return page;
    });
  }

  return pages;
}

const customerPages: PageControlState = getCustomerPages();

export default customerPages;